import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { formatINR } from "@/lib/api";

export default function Services() {
    return (
        <div data-testid="services-page" className="pt-32 pb-20">
            <div className="container-vv">
                <div className="max-w-3xl mb-16">
                    <div className="label-eyebrow">Consultations</div>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream mt-4 text-balance">
                        Twelve precise <span className="italic text-gold">paths</span> to clarity.
                    </h1>
                    <p className="mt-6 text-cream-muted leading-relaxed text-lg">
                        Each service is a complete, focused session designed to address a specific life domain — with practical remedies and a written summary where applicable.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {SERVICES.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div key={s.slug} className="card-luxe group flex flex-col" data-testid={`service-card-${s.slug}`}>
                                <div className="flex items-start justify-between mb-6">
                                    <div className="h-12 w-12 rounded-xl border border-gold/30 grid place-items-center bg-ink-deep/60 group-hover:border-gold transition-colors">
                                        <Icon className="h-5 w-5 text-gold" />
                                    </div>
                                    {s.tag && <span className="text-[10px] tracking-widest uppercase text-gold border border-gold/40 px-2 py-1 rounded-full">{s.tag}</span>}
                                </div>
                                <h3 className="font-serif text-2xl text-cream mb-3">{s.name}</h3>
                                <p className="text-sm text-cream-muted leading-relaxed mb-6 flex-1">{s.blurb}</p>
                                <div className="flex items-center justify-between pt-5 border-t border-gold/15">
                                    <div>
                                        <div className="font-serif text-xl text-gold">{formatINR(s.priceInr)}</div>
                                        <div className="text-xs text-cream-muted">{s.duration}</div>
                                    </div>
                                    <Link to={`/booking?service=${s.slug}`} className="text-sm text-gold flex items-center gap-1 group-hover:gap-2 transition-all" data-testid={`book-btn-${s.slug}`}>
                                        Book Now <ArrowRight className="h-3.5 w-3.5" />
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
